import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { getChapterImg } from '../../lib/utils';

export default class ChapterImage extends Component {
    render() {
        const { collectionId, thumbnail, width } = this.props;
        if (!thumbnail) {
            return <></>
        }
        const imageWidth = width || '300px';
        return (
            <div style={{}}>
                <img src={getChapterImg(collectionId, thumbnail)} style={{ width: imageWidth, maxWidth: '100%' }} />
            </div>
        )
    }
}

ChapterImage.propTypes = {
    collectionId: PropTypes.any,
    thumbnail: PropTypes.string,
    width: PropTypes.string
}